import React from "react";

const Welcome = () => (
  <div>
    <h2> Name </h2>
    Welcome To my Page
  </div>
);

export default Welcome;



// WEBPACK FOOTER //
// ./src/Welcome.js